import { Component } from '@angular/core';
import { PushNotificationService } from '../../../data/services/push-notification.service';

@Component({
  selector: 'app-auth-layout',
  template: `
    <app-push-notification *ngIf="showChatNotifications"></app-push-notification>
    <app-nav-sidebar>
      <router-outlet></router-outlet>
    </app-nav-sidebar>
  `,
})
export class AuthLayoutComponent {
  get showChatNotifications(): boolean {
    return this.notificationService.isChatNotificationsActive;
  }

  constructor(
    private readonly notificationService: PushNotificationService
  ) {}
}
